module.exports = __webpack_public_path__ + "static/img/iconoffice.771512ea.svg";